import chroma from "chroma-js"
export function CSSRGB(col){
    return `rgb(${col[0]},${col[1]},${col[2]})`
}
export function getComplement(row,id){
  let r = (row+1) % 2
  let length = colors[0].length
  let ids =[id,(id+1)%length,(id+length-1)%length]
  let cols = []
  ids.forEach(id=>{
    cols.push(colors[r][id])
  })
  return cols
}

export function setTint(color,tintValue){
  let hsl = chroma(...color).hsl()
  let tint = chroma.hsl(hsl[0],hsl[1],tintValue).rgb()
  return tint
}

export const colors = [
  [
    //FIRST ROW
    [60, 100, 30],
    [0, 130, 150],
    [20, 20, 170],
    [105, 0, 117],
    [180, 0, 0],
  ],
  [
    //SECOND ROW
    [230, 220, 90],
    [150, 230, 219],
    [200, 200, 255],
    [230, 140, 220],
    [255, 199, 120],
  ],
];
